const LoadingMessageCode = {
    IDLE: 0,
    DONE_LOADING: 100,
    SIDE_ERROR_EXIST: 1000,
    BREAKING_ERROR_EXIST: 10000
};

export default LoadingMessageCode;
